import "./CarouselLogos.scss";
import React, { useEffect, useRef } from "react";

interface LogoCarouselProps {
  logos: {
    name: string;
    img: string;
    style?: any;
  }[];
}

const LogoCarousel: React.FC<LogoCarouselProps> = ({ logos }) => {
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = scrollContainerRef.current;
    if (!container) return;

    let animationFrame: number;
    let scrollAmount = 0;

    const scrollLogos = () => {
      scrollAmount += 2;
      if (scrollAmount >= container.scrollWidth / 2) {
        scrollAmount = 0;
      }
      container.scrollLeft = scrollAmount;
      animationFrame = requestAnimationFrame(scrollLogos);
    };

    animationFrame = requestAnimationFrame(scrollLogos);

    return () => cancelAnimationFrame(animationFrame);
  }, []);

  return (
    <div id="carousel-logos">
      <div ref={scrollContainerRef}>
        {[...logos, ...logos].map((logo, index) => (
          <div key={index}>
            <img src={logo.img} alt={`Logo ${index}`} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default LogoCarousel;
